import { useState } from "react";
import { toast } from "sonner";
import { p, errMsg } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck, Trash2, Lock } from "lucide-react";

/** I tuoi dati: cosa custodiamo e come chiedere la cancellazione definitiva (diritto GDPR). */
export const DatiPersonali = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const CONFIRM = t("gdpr.word");

  const ask = async () => {
    setBusy(true);
    try {
      const r = await p("/tenant/delete-request", { email: email.trim(), reason: "richiesta dal titolare" });
      toast.success(t("gdpr.sent", { mail: r.sent_to }));
      setOpen(false);
      setWord("");
      setEmail("");
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  return (
    <Card className="p-6" data-testid="gdpr-card">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-lg bg-slate-900 p-2 text-white">
          <Lock className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <h3 className="text-lg font-semibold">{t("gdpr.title")}</h3>
          <p className="mt-1 text-sm text-slate-500">{t("gdpr.sub")}</p>
        </div>
      </div>

      <ul className="mt-4 space-y-1.5 text-sm text-slate-600">
        {["gdpr.p1", "gdpr.p2", "gdpr.p3"].map((k) => (
          <li key={k} className="flex items-start gap-2">
            <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> {t(k)}
          </li>
        ))}
      </ul>

      {!open ? (
        <Button variant="outline" className="mt-5 h-12 border-rose-200 text-rose-700 hover:bg-rose-50"
                onClick={() => setOpen(true)} data-testid="gdpr-delete-open-btn">
          <Trash2 className="mr-1.5 h-4 w-4" /> {t("gdpr.delete")}
        </Button>
      ) : (
        <div className="mt-5 space-y-3 rounded-lg border border-rose-200 bg-rose-50 p-4" data-testid="gdpr-delete-form">
          <p className="text-sm font-semibold text-rose-900">{t("gdpr.warn")}</p>
          <Input className="h-12 bg-white" placeholder={t("gdpr.email")} value={email}
                 onChange={(e) => setEmail(e.target.value)} data-testid="gdpr-email-input" />
          <Input className="h-12 bg-white" placeholder={t("gdpr.type", { word: CONFIRM })} value={word}
                 onChange={(e) => setWord(e.target.value.toUpperCase())} data-testid="gdpr-word-input" />
          <div className="flex flex-wrap gap-2">
            <Button className="h-12 bg-rose-600 hover:bg-rose-700" disabled={busy || word !== CONFIRM || !email.trim()}
                    onClick={ask} data-testid="gdpr-delete-confirm-btn">
              {t("gdpr.send")}
            </Button>
            <Button variant="ghost" className="h-12" onClick={() => setOpen(false)} data-testid="gdpr-delete-cancel-btn">
              {t("gdpr.cancel")}
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};
